/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './CostBasisMethod.scss';

import { bool } from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';

import LegalCopy from 'components/shared/LegalCopy/LegalCopy';
import Content from 'services/Content';
import { hasBrokerageAccount } from 'state/account/AccountSelectors';
import { isMobileLayout } from 'state/view/ViewSelectors';
import FAQ from 'components/shared/FAQAccordion/FAQ';
import Registration from './Registration';
import {
  getTaxes,
  updateBrokerageCostBasis,
  updateCustomerPreferences
} from 'services/Rest';
import Store from 'state/Store';
import { errorUpdateCostBasisMethod } from 'state/taxes/TaxActions';
import { getCostBasisElections } from 'state/taxes/TaxSelectors';
import { generateCostBasisPayload } from './CostBasisUtils';

const CostBasisMethod = ({ isMobileLayout }) => {
  useEffect(() => {
    getTaxes();
  }, []);
  const submitCostBasis = async (query) => {
    try {
      const payload = generateCostBasisPayload(
        query,
        query.account.isBrokerage
      );
      if (!query.account.isBrokerage) {
        updateCustomerPreferences(
          payload,
          () => {},
          () => {
            Store.dispatch(errorUpdateCostBasisMethod());
          }
        );
      } else {
        await updateBrokerageCostBasis(
          payload,
          () => {
            getTaxes();
          },
          () => {
            Store.dispatch(errorUpdateCostBasisMethod());
          }
        );
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <Fragment>
      <div className="cost-basis-method-header-v2 b-font-weight-bold b-typography-sans-serif--headline--600">
        Cost Basis Method
      </div>
      {!isMobileLayout && (
        <h2 className="cost-basis-method-sub-header-v2 b-font-weight-bold b-typography-sans-serif--headline--500">
          My Accounts
        </h2>
      )}
      <div className="cost-basis-content-v2">
        <span className="col-1-v2">
          <Registration submitCostBasis={submitCostBasis} />
        </span>
        <span className="col-2-v2">
          <FAQ />
        </span>
      </div>
      <div className="cost-basis-legal-copy-v2">
        <LegalCopy content={Content.costBasisMethodPreferencesV2} />
      </div>
    </Fragment>
  );
};

CostBasisMethod.propTypes = {
  hasBrokerageAccount: bool.isRequired,
  isMobileLayout: bool.isRequired
};

const mapStateToProps = (state) => ({
  currentCostBasisElections: getCostBasisElections(state),
  hasBrokerageAccount: hasBrokerageAccount(state),
  isMobileLayout: isMobileLayout(state),
  router: state.router
});

export default connect(mapStateToProps)(CostBasisMethod);
